import React from 'react';

import { Container, Row, Col, Paragraph, HeadingThree, SmallText } from '../';

const chatBubble = 'https://assets.homeimprovementpages.com.au/images/alexa/chat-bubble.png';

const ContainerChat = Container.extend`
  background-color: #a3b0b0;
  background-image: linear-gradient(to bottom, #ffffff 0%, #a3b0b0 100%);
`;

const ChatBubbleRow = Row.extend`
  position: relative;
  left: -18px;
  height: 450px;
  justify-content: center;

  .bubble {
    p {
      position: absolute;
      top: 0;
      left: 44px;
      width: 350px;
      height: 100px;
      text-align: center;
      align-items: center;
      display: flex;
      justify-content: center;
      font-size: 15px;
    }

    height: 140px;
    top: 0;

    &.left-bubble {
      z-index: 4;
      position: relative;
    }

    &.middle-bubble {
      z-index: 3;
      position: relative;
    }

    &.right-bubble {
      z-index: 2;
      position: relative;
    }

    &.left-bottom-bubble {
      position: absolute;
      z-index: 1;
      top: 25px;
      left: 0;
      opacity: 0.3;
    }

    &.middle-bottom-bubble {
      position: absolute;
      z-index: 1;
      top: 160px;
      left: 250px;
      opacity: 0.3;
    }

    img {
      width: 394px;
      height: 158px;
    }
  }

  @media (min-width: 48rem) {
    // left: -35px;

    .bubble {
      // position: absolute;
      // height: 230px;
    }
  }

  @media (min-width: 60rem) {
    height: 200px;
    left: -35px;

    .bubble {
      position: absolute;
      height: 230px;

      &.left-bubble {
        top: 0;
      }

      &.middle-bubble {
        top: 25px;
      }

      &.right-bubble {
        top: 50px;
      }

      &.left-bottom-bubble {
        top: 0;
        left: 580px;
        opacity: 0.7;
      }

      &.middle-bottom-bubble {
        top: 70px;
        left: 170px;
        opacity: 0.6;
      }
    }
  }

  @media (max-width: 380px) {
    .bubble {
      img {
        width: 83%;
        height: 158px;
      }
    }
  }
`;

// eslint-disable-next-line react/display-name
export default () => (
  <ContainerChat mt={1} fluid center>
    <Row>
      <Col xs={12} center>
        <HeadingThree mt={0.25} style={{ fontWeight: 300, fontSize: '38px' }}>
          Get Started
        </HeadingThree>
        <Container center mt={1} style={{ overflow: 'hidden' }}>
          <Row>
            <Col xs={12} center>
              <Paragraph style={{ fontSize: '15px' }} pl={{ xs: 1, md: 7 }} pr={{ xs: 1, md: 7 }}>
                Open the Alexa app or go to{' '}
                <a
                  href="//alexa.amazon.com.au"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-ga-category="Alexa Page"
                  data-ga-action="Get Started"
                  data-ga-label="Click Alexa Link"
                >
                  <strong>alexa.amazon.com.au</strong>
                </a>, tap Skills and search for &quot;hipages&quot;. Select the hipages Find a
                Tradie skill and tap Enable. Once the <strong>hipages Find a Tradie</strong> skill
                is enabled, say one of the following to get started.
              </Paragraph>
            </Col>
          </Row>
          <ChatBubbleRow mt={2.4}>
            <Col md={12} lg={4} center>
              <div className="bubble left-bubble">
                <img src={chatBubble} />
                <Paragraph>&quot;Alexa, launch hipages&quot;</Paragraph>
              </div>
              <div className="bubble left-bottom-bubble">
                <img src={chatBubble} />
              </div>
              <div className="bubble middle-bottom-bubble">
                <img src={chatBubble} />
              </div>
            </Col>
            <Col md={12} lg={4} center>
              <div className="bubble middle-bubble">
                <img src={chatBubble} />
                <Paragraph>&quot;Alexa, ask hipages to find me a plumber&quot;</Paragraph>
              </div>
            </Col>
            <Col md={12} lg={4} center>
              <div className="bubble right-bubble">
                <img src={chatBubble} />
                <Paragraph>&quot;Alexa, ask hipages to find a tradie&quot;</Paragraph>
              </div>
            </Col>
          </ChatBubbleRow>
        </Container>
      </Col>
    </Row>
    <Container>
      <Row mt={{ md: 0, lg: 2.5 }} pb={{ md: 1, lg: 2.2 }}>
        <Col xs={0} lg={3} center />
        <Col xs={12} lg={4} center>
          <div>
            <a
              style={{ marginRight: '10px' }}
              href="https://itunes.apple.com/au/app/amazon-alexa/id944011620?mt=8"
              title="Download the hipages app on the App Store"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                role="presentation"
                alt="App Store"
                src="https://assets.homeimprovementpages.com.au/images/logo-app-store-v3.png"
                width="120"
                height="40"
              />
            </a>
            <a
              style={{ marginLeft: '10px' }}
              href="https://play.google.com/store/apps/details?id=com.amazon.dee.app"
              title="Download the hipages app on the Play Store"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                role="presentation"
                alt="Play Store"
                src="https://assets.homeimprovementpages.com.au/images/logo-google-play-v3.png"
                width="120"
                height="40"
              />
            </a>
          </div>
          <SmallText style={{ fontSize: '13px' }} mt={1}>
            You can download the Alexa app for iOS and Android
          </SmallText>
        </Col>
        <Col xs={12} lg={2} center>
          <div>
            <a
              href="https://www.amazon.com.au/gp/product/B0786YJMCS"
              title="Just Ask Amazon Alexa"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                role="presentation"
                alt="Just Ask Amazon Alexa"
                src="https://assets.homeimprovementpages.com.au/images/alexa/just-ask-alexa.png"
                width="157"
                height="40"
              />
            </a>
          </div>
          <SmallText style={{ fontSize: '13px' }} mt={1}>
            Amazon Skill Store
          </SmallText>
        </Col>
        <Col xs={0} lg={3} center />
      </Row>
    </Container>
  </ContainerChat>
);
